import React, { useEffect, useLayoutEffect } from "react";
import { NextSeo } from "next-seo";
import LoginForm from "domains/auth/components/LoginForm";
import useFollowMouse from "domains/commons/hooks/useFollowMouse";
import useRouter from "domains/navigation/hooks/useRouter";
import Footer, { FOOTER_HEIGHT } from "domains/ui/components/Footer";
import Loading from "domains/ui/components/Loading";
import { useWindowSize } from "domains/ui/hooks/useWindowSize";
import { AnalyticsEvents } from "infra/analytics/constants/Events";
import Track from "infra/analytics/Track";

import { Box, Center, VStack } from "@chakra-ui/react";

export default function LoginPage() {
  const router = useRouter();
  const { width: windowWidth } = useWindowSize();

  const offset = useFollowMouse({ maxOffset: 20 });

  useEffect(() => {
    const { referral } = router.query;

    if (referral && typeof referral === "string") {
      Track(AnalyticsEvents.Signup.ReferralCaptured, {
        referral,
      });
    }
  }, [router]);

  useLayoutEffect(() => {
    Track(AnalyticsEvents.Login.RenderedLoginPage, {});
  }, []);

  if (windowWidth === undefined) {
    return (
      <Center h="100vh">
        <Loading />
      </Center>
    );
  }

  return (
    <>
      <NextSeo title="Login" />

      <Center
        pos="relative"
        overflow="hidden"
        w="100vw"
        h={`calc(100vh - ${FOOTER_HEIGHT}px)`}
        bgColor="black"
      >
        <Box
          pos="absolute"
          zIndex={0}
          top="calc(50vh - min(20vh, 20vw))"
          left="50%"
          w={["600px", "700px", "min(60vw, 60vh)"]}
          h={["600px", "700px", "min(60vw, 60vh)"]}
          opacity={0.28}
          borderRadius="full"
          transform={`translate(-50%, -50%) translate(${offset.x}px, ${offset.y}px)`}
          userSelect="none"
          pointerEvents="none"
          bgColor="primary.500"
          filter="blur(175px)"
        />

        <VStack
          w={{
            base: "90vw",
            sm: "350px",
            md: "400px",
            lg: "450px",
            xl: "500px",
          }}
          maxW="95vw"
        >
          <LoginForm />
        </VStack>
      </Center>

      <Footer />
    </>
  );
}
